<span class="line-clamp-1 text-sm font-medium tracking-tighter text-primary">{{date()}}</span>
